import React from "react";
import { TextField } from "@mui/material";
import { Controller } from "react-hook-form";
import IMask from "react-input-mask";
import PropTypes from "prop-types";
import { noop } from "lodash";
import { normalizeFormField } from "../../utils/formUtilis";

const CoTextField = ({
  control,
  name,
  sx,
  placeholder,
  type,
  disabled,
  isAccess = true,
  display = true,
  disabledField = false,
  corticonField = false,
  isCurrency = false,
  isPercentage = false,
  colorind = "",
  onChangeProp,
  normalizers,
  maskProps,
  large,
  ...props
}) => {
  // Hide field if `display` is false
  if (!display) return null;

  return (
    <Controller
      name={name}
      control={control}
      defaultValue=""
      render={({ field: { onChange, ref, value, ...field }, fieldState: { error } }) => {
        const handleChange = (e) => {
          let newValue = e.target.value.replace("%", "");

          // Normalize input if normalizers are provided
          if (normalizers) {
            newValue = normalizeFormField(newValue, normalizers);
          }

          // Remove currency formatting before storing
          if (isCurrency) {
            newValue = removeCurrencyFormatting(newValue);
          }

          onChange(newValue);
          if (onChangeProp) onChangeProp(newValue);
        };
        const formatPercentage = (val) => {
          if (!val && val !== 0) return "";
          return `${val}%`;
        };

        const inputSx = {
          height: large ? "15px" : "11px",
          padding: large ? "18.5px 12px" : "16.5px 12px",
          fontSize: large ? "16px" : "14px",
          "&::placeholder": {
            fontSize: large ? "16px" : "14px",
          },
        };

        const combinedSx = {
          "& .MuiInputBase-input": inputSx,
          "& .MuiOutlinedInput-root": {
            "& fieldset": {
              borderColor: colorind || "", // Apply custom border color
            },
            "&.Mui-disabled": {
      backgroundColor: "#F2F2F2", // Set background color for disabled field
    },
            "&:hover fieldset": {
              borderColor: colorind || "",
            },
            "&.Mui-focused fieldset": {
              borderColor: colorind || "",
            },
            "&.Mui-disabled fieldset": {
              borderColor: "#D3D3D3", // Optional: Change border color when disabled
            },
          },
          ...sx,
        };
        

        if (maskProps) {
          return (
            <IMask disabled={disabled || !isAccess || disabledField} {...maskProps} {...field} onChange={handleChange}>
              {(inputPropsMask) => (
                <TextField
                  {...inputPropsMask}
                  {...props}
                  inputRef={ref}
                  sx={combinedSx}
                  placeholder={placeholder}
                  type={type}
                  disabled={!isAccess || disabledField ||disabled}
                  InputProps={{
                    readOnly: !isAccess || corticonField,
                  }}
                />
              )}
            </IMask>
          );
        }

        return (
          <TextField
            {...field}
            id="outlined-disabled"
            {...props}
            value={
              isPercentage
                ? formatPercentage(value)
                : isCurrency
                ? formatCurrency(value)
                : value
            }
            onChange={handleChange}
            inputRef={ref}
            sx={combinedSx}
            placeholder={placeholder}
            type={type}
            disabled={!isAccess || disabledField || disabled}
            // error={!!error}
            // helperText={error?.message}
            InputProps={{
              readOnly: !isAccess || corticonField,
              maxLength: props.maxLength,
              startAdornment: props.startAdornment,
            }}
          />
        );
      }}
    />
  );
};

// Function to format currency
const formatCurrency = (value) => {
  if (!value) return "";
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: 2,
  }).format(Number(value));
};

// Function to remove currency formatting
const removeCurrencyFormatting = (value) => {
  return value.replace(/[^0-9.-]+/g, ""); // Keep only numbers and decimals
};


CoTextField.propTypes = {
  control: PropTypes.object.isRequired,
  name: PropTypes.string.isRequired,
  sx: PropTypes.object,
  placeholder: PropTypes.string,
  type: PropTypes.string,
  disabled: PropTypes.bool,
  isAccess: PropTypes.bool,
  display: PropTypes.bool,
  disabledField: PropTypes.bool,
  corticonField: PropTypes.bool,
  isCurrency: PropTypes.bool,
  isPercentage: PropTypes.bool,
  colorind: PropTypes.string,
  maskProps: PropTypes.object,
  normalizers: PropTypes.array,
  large: PropTypes.bool,
  onChangeProp: PropTypes.func,
};

CoTextField.defaultProps = {
  sx: {},
  placeholder: "",
  type: "text",
  disabled: false,
  isAccess: true,
  display: true,
  disabledField: false,
  corticonField: false,
  isCurrency: false,
  isPercentage: false,
  colorind: "",
  maskProps: null,
  normalizers: null,
  large: false,
  onChangeProp: noop,
};

export default CoTextField;
